import WarningIcon from '@mui/icons-material/Warning';

interface NoTransactionWarningProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  customContent: JSX.Element;
}

const NoTransactionWarning = ({ title, customContent, ...props }: NoTransactionWarningProps) => {
  return (
    <div className="connector-details-no-transaction-warning" {...props}>
      <div>
        <WarningIcon />
        <p>{title}</p>
      </div>
      <div />
      {customContent}
    </div>
  );
};

export default NoTransactionWarning;
